/**
 * Obtiene los datos de una ubicación geográfica a partir de un código postal.
 *
 * @param input
 * @param codigoPostal
 * @param prefix
 */
window.setComunidadAutonomaYProvinciaByCodigoPostal = function (input, codigoPostal, seccion = '') {
    let provincia         = '';
    let provinciaId       = null;
    let comunidadAutonoma = '';

    const dataToSend = {
        selectFields: [
            "provincias.id as provincia_id",
            "idioma_provincia.titulo as provincia",
            "comunidad_autonoma_idioma.titulo as comunidad_autonoma"
        ],
        searchFields: {
            codigo_provincia:     codigoPostal.substring(0, 2),
            "idiomas.codigo_iso": locale
        },
        join:         {
            idioma_provincia:          {
                on: [
                    "idioma_provincia.provincia_id",
                    "provincias.id"
                ]
            },
            comunidad_autonoma_idioma: {
                on:           [
                    "comunidad_autonoma_idioma.comunidad_autonoma_id",
                    "provincias.comunidad_autonoma_id"
                ],
                searchFields: {
                    "comunidad_autonoma_idioma.idioma_id": "`comunidad_autonoma_idioma`.`idioma_id` = `idioma_provincia`.`idioma_id`"
                },
                conditions:   {
                    "comunidad_autonoma_idioma.idioma_id": "raw"
                }
            },
            idiomas:                   {
                on: [
                    "idiomas.id",
                    "idioma_provincia.idioma_id"
                ]
            }
        }
    };

    $.ajax({
        url:      urlProvincia + '/get',
        type:     'POST',
        data:     dataToSend,
        dataType: 'json',
    })
     .done(function (response) {
         if (response.list.length > 0) {
             provincia         = response.list[0].provincia;
             provinciaId       = response.list[0].provincia_id;
             comunidadAutonoma = response.list[0].comunidad_autonoma;
         }
     })
     .fail(function (jqXHR, status, error) {
         if (jqXHR.status) {
             let errors = '';
             if (jqXHR.status === 422) {
                 errors = composeValidationError(jqXHR.responseJSON.errors);
             } else if (jqXHR.responseJSON.message) {
                 errors = jqXHR.responseJSON.message;
             }
             pNotifyError(errors);
         }
     })
     .always(function () {
         let $form = $(input).closest('form');
         $form.find(`input[id="direccionFormulario${seccion}CampoProvincia"]`).val(provincia).data('provincia_id', provinciaId);
         $form.find(`input[id="direccionFormulario${seccion}CampoComunidad_autonoma"]`).val(comunidadAutonoma);
     });
}
